import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyDefaultAPI from '../../api';

const postTruckData = async ({ data }) => {
  try {
    const response = await safetyDefaultAPI.post('truck', data);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default postTruckData;
